import { RESOURCES_TYPES } from '@/constants/resourcesTypes';

export const filterItemsByResourceType = (items: any, type: any) => {
  // Méta-type « Tout » : aucun filtre — les résultats sont déjà l'agrégat de
  // toutes les ressources (chaque item porte son propre `_type`).
  if (type === RESOURCES_TYPES.ALL) return items;
  return items.filter((item: any) => item._type === type);
};
